import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ChartsPage from "./Charts";
import AdminsPage from "./users/Admins";
import StaffsPage from "./users/Staffs";
import ManagerPage from "./users/Managers";
import NewUserPage from "./users/New";
import ActivityPage from "./Activity";

export default function ManagePage() {
  return (
    <Routes>
      <Route path="/users/admins" element={<AdminsPage />} />
      <Route path="/users/staffs" element={<StaffsPage />} />
      <Route path="/users/managers" element={<ManagerPage />} />
      <Route path="/users/new" element={<NewUserPage />} />
      <Route path="/charts" element={<ChartsPage />} />
      <Route path="/activity" element={<ActivityPage />} />
      <Route path="*" element={<Navigate to="/error/error1" replace />} />
    </Routes>
  );
}
